export default __webpack_public_path__ + "static/media/bayern_dark.9e72329a.png";